'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFromVisitor = exports.isFromRep = exports.isFrom = exports.isOfflineMessage = exports.isChatMessage = exports.isInitialMessage = exports.getAllowUserInput = exports.getAllowMultiSelect = exports.getQuickReplies = exports.getQuickReply = exports.getWelcomeMessageId = exports.getUrl = exports.getFrom = undefined;
exports.getText = getText;
exports.getRichText = getRichText;
exports.isConversationalMessage = isConversationalMessage;

var _underscore = require('underscore');

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REP = _RoleTypes2.default.REP,
    VISITOR = _RoleTypes2.default.VISITOR;


var KEY_PATHS = {
  FROM: ['metadata', 'from'],
  RICH_TEXT: ['metadata', 'richText'],
  TEXT: ['metadata', 'text'],
  URL: ['metadata', 'url'],
  WELCOME_MESSAGE_ID: ['metadata', 'welcomeMessageId'],
  QUICK_REPLY: ['metadata', 'quickReply'],
  QUICK_REPLIES: ['metadata', 'quickReply', 'quickReplies'],
  ALLOW_MULTI_SELECT: ['metadata', 'quickReply', 'allowMultiSelect'],
  ALLOW_USER_INPUT: ['metadata', 'quickReply', 'allowUserInput']
};

var CONVERSATIONAL_MESSAGE_TYPES = (0, _immutable.List)([_PubNubMessageTypes.INITIAL_MESSAGE, _PubNubMessageTypes.CHAT_MESSAGE, _PubNubMessageTypes.OFFLINE]);

var getFrom = exports.getFrom = (0, _getIn2.default)(KEY_PATHS.FROM);

function getText(message) {
  return (0, _getIn2.default)(KEY_PATHS.TEXT, message);
}

function getRichText(message) {
  return (0, _getIn2.default)(KEY_PATHS.RICH_TEXT, message) || (0, _underscore.escape)(getText(message));
}

var getUrl = exports.getUrl = (0, _getIn2.default)(KEY_PATHS.URL);

var getWelcomeMessageId = exports.getWelcomeMessageId = (0, _getIn2.default)(KEY_PATHS.WELCOME_MESSAGE_ID);

var getQuickReply = exports.getQuickReply = (0, _getIn2.default)(KEY_PATHS.QUICK_REPLY);

var getQuickReplies = exports.getQuickReplies = (0, _getIn2.default)(KEY_PATHS.QUICK_REPLIES);

var getAllowMultiSelect = exports.getAllowMultiSelect = (0, _getIn2.default)(KEY_PATHS.ALLOW_MULTI_SELECT);

var getAllowUserInput = exports.getAllowUserInput = (0, _getIn2.default)(KEY_PATHS.ALLOW_USER_INPUT);

var isInitialMessage = exports.isInitialMessage = (0, _PubNubMessageModel.isType)(_PubNubMessageTypes.INITIAL_MESSAGE);

var isChatMessage = exports.isChatMessage = (0, _PubNubMessageModel.isType)(_PubNubMessageTypes.CHAT_MESSAGE);

var isOfflineMessage = exports.isOfflineMessage = (0, _PubNubMessageModel.isType)(_PubNubMessageTypes.OFFLINE);

var isFrom = exports.isFrom = (0, _curry2.default)(function (role, message) {
  return getFrom(message) === role;
});

var isFromRep = exports.isFromRep = isFrom(REP);

var isFromVisitor = exports.isFromVisitor = isFrom(VISITOR);

function isConversationalMessage(props) {
  var type = (0, _PubNubMessageModel.getType)(props);
  return CONVERSATIONAL_MESSAGE_TYPES.includes(type);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/models/ConversationalMessageModel.js
// module id = 9
// module chunks = 0 1